import {gql} from '@apollo/client';

import {CheckoutFragment} from 'services/checkout/constants/fragments';

export const GET_CHECKOUT_BY_ID = gql`
  ${CheckoutFragment}
  query getCheckoutById($checkoutId: String!) {
    getCheckoutById(checkoutId: $checkoutId) {
      ...checkout
    }
  }
`;
